import { Currency } from '.'
import { useCart } from './Cart'
import { Spinner } from './Spinner'

export function CartSummary({ action }) {
    const cart = useCart()

    if (cart.loading)
        return (
            <div className="w-auto bg-white rounded-xl p-8 shadow-md flex justify-center align-middle">
                <Spinner />
            </div>
        )

    return (
        <div className="w-auto bg-white rounded-xl p-8 shadow-md">
            <div className="flex justify-between mb-4">
                <span className="text-gray-500">قیمت کالاها</span>
                <span className="text-gray-500">
                    {cart?.totals?.subtotal && <Currency value={cart.totals.subtotal} />}
                </span>
            </div>
            <div className="flex justify-between mb-4">
                <span className="text-gray-500">تخفیف کالاها</span>
                <span className="text-red-500">
                    {cart.totals.items_discounts > 0 && <Currency value={cart.totals.items_discounts} />}
                    {!cart.totals.items_discounts && '---'}
                </span>
            </div>
            <div className="flex justify-between mb-4">
                <span className="text-gray-500">هزینه ارسال</span>
                <span className="text-gray-500">
                    <Currency value={cart?.totals?.shippings_total ?? 0} />
                </span>
            </div>
            <div className="flex justify-between mb-4 mt-4 border-t-2 border-indigo-400 border-dashed pt-4">
                <span className="text-gray-800 text-lg font-bold">جمع سبد خرید</span>
                <span className="text-gray-800 text-lg font-bold text-left">
                    {cart?.totals?.total && <Currency value={cart.totals.total} />}
                </span>
            </div>
            {action}
        </div>
    )
}
